// The cart builder's bulk-paste section: what goes to the server and how its
// answer becomes rows a rep acts on.
//
// Lives outside the component so it runs under `node --test`. The server side
// is squish-crm-backend's GET /api/domain-check-bulk, which answers one row
// per domain, in the order sent, each shaped like the single check:
//   [{ domain, available, price, transferPrice }]
//
// THE BUG (found 2026-10-21): the section called that path before the route
// existed — only /api/domain-check was registered — so every "Check all" read
// "Unexpected token '<'" off the HTML 404. The parser here used to expect a
// registrar-style nesting ({ data: { DomainInfo: { domainAvailability … } } })
// copied from a guess about a different backend; the route that now exists
// speaks the single check's flat shape, so one parser serves both.

export const BULK_CHECK_PATH = '/api/domain-check-bulk';
export const BULK_CHECK_MAX = 50;

// One domain per line (commas and whitespace also split). Lowercased,
// deduplicated, and only the entries that could be a domain.
export function parseBulkInput(text) {
  const domains = String(text || '').split(/[\s,]+/).map(s => s.trim().toLowerCase()).filter(Boolean);
  const unique = Array.from(new Set(domains));
  return unique.filter(d => /^[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(d));
}

// The server's rows → the section's rows. Default action is what a rep most
// likely wants: register a free name, transfer a taken one that has a transfer
// price, skip a taken one without.
export function rowsFromBulkCheck(data) {
  return (Array.isArray(data) ? data : []).map(r => {
    const available     = r.available === true;
    const price         = available && r.price != null ? Number(r.price) : null;
    const transferPrice = !available && r.transferPrice != null ? Number(r.transferPrice) : null;
    return {
      domain: r.domain,
      available,
      price,
      transferPrice,
      action: available ? 'register' : (transferPrice != null ? 'transfer' : 'skip'),
      years: 1,
      eppCode: '',
    };
  });
}
